var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lp-toolbar-textarea-color-container"},[_c('preset-input-color',{staticClass:"lp-toolbar-textarea-color",attrs:{"value":_vm.editor.getAttributes('textStyle').color,"small":true,"closeButton":_vm.closeButton},on:{"input":_vm.handleSelectColor,"menuOpened":_vm.handleMenuState}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }